import React, { MutableRefObject, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
// third party components
import { Menu as HMenu } from '@headlessui/react'

// resources
import BrowseIcon from 'assets/icons/menu-browse-icon.svg?component'
import LeaderboardIcon from 'assets/icons/menu-leaderboard-icon.svg?component'
import GenreIcon from 'assets/icons/menu-genre-icon.svg?component'

// styles
import styles from './index.module.scss'
import { useRouter } from 'next/router'

export interface ExploreMenuNewProps<T> {
  showCategory: any
}

const ExploreMenuNew = <T,>({ showCategory }: ExploreMenuNewProps<T>) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const menuRef = useRef<HTMLElement | null>(null)
  const itemRef = useRef<HTMLElement | null>(null)

  const [isMenuOpen, setIsMenuOpen] = React.useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleClickOutside = event => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      itemRef.current &&
      !itemRef.current.contains(event.target)
    ) {
      setIsMenuOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  })

  return (
    <div className="flex items-center">
      <HMenu>
        <HMenu.Button ref={itemRef as MutableRefObject<HTMLButtonElement>}>
          <div
            className={styles.container}
            onClick={() => {
              toggleMenu()
            }}
          >
            <div>Explore</div>
          </div>
        </HMenu.Button>
        {isMenuOpen && (
          <div ref={menuRef as MutableRefObject<HTMLDivElement>} className={styles.menuArea}>
            <div className="flex flex-col">
              <div
                className={styles.topSection}
                onClick={() => {
                  router.push('/explore')
                  setIsMenuOpen(false)
                }}
              >
                <div className="w-full flex gap-[15px] items-center">
                  <div className={styles.iconArea}>
                    <BrowseIcon />
                  </div>
                  <div>
                    <div className={styles.title}>Browse</div>
                    <div className={styles.desc}>Artworks, creators, and collections</div>
                  </div>
                </div>
                <div className={styles.border} />
              </div>
              <div
                className={styles.middleSection}
                onClick={() => {
                  dispatch({ type: 'set', activeTab: 2 })
                  router.push('/leaderboard')
                  setIsMenuOpen(false)
                }}
              >
                <div className="w-full flex gap-[15px] items-center">
                  <div className={styles.iconArea}>
                    <LeaderboardIcon />
                  </div>
                  <div>
                    <div className={styles.title}>Leaderboard</div>
                    <div className={styles.desc}>{`Track what's trending`}</div>
                  </div>
                </div>
                <div className={styles.border} />
              </div>

              <div
                className={styles.bottomSection}
                onClick={() => {
                  setIsMenuOpen(false)
                  showCategory()
                }}
              >
                <div className="w-full flex gap-[15px] items-center">
                  <div className={styles.iconArea}>
                    <GenreIcon />
                  </div>
                  <div>
                    <div className={styles.title}>Genres</div>
                    <div className={styles.desc}>Explore artwork by genre</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </HMenu>
    </div>
  )
}

export default ExploreMenuNew
